import { SyncCheck } from './sync-check';
import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable()
export class SyncGuard implements CanDeactivate<SyncCheck> {
  canDeactivate(
    component: SyncCheck,
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return component.isSync ? component.isSync() : true;
  }
}
